<script setup lang="ts">
import SearchInput from "./components/search-input.vue";
import ContentList from "./components/content-list/content-list.vue";
import { onMounted, ref } from "vue";
import { request } from "./api/request";

const formData = ref({});
const onSearch = (data) => {
  formData.value = { ...data };
};
const onReset = () => {
  const data = { city: "", search: "" };
  formData.value = { ...data };
};

onMounted(() => {
  request("web.basicBiz.address.getMultiLevelSubList", {
    districtLevel: "province",
  });
});
</script>

<template>
  <SearchInput @search="onSearch" @reset="onReset" />
  <ContentList :city="formData.city" :jobName="formData.search" />
</template>
